import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Star } from 'lucide-react';
export function Hero() {
  return <section id="inicio" className="relative h-screen w-full flex items-center justify-center overflow-hidden" data-id="element-133">
      {/* Background Video */}
      <div className="absolute inset-0 z-0" data-id="element-134">
        <video autoPlay loop muted playsInline className="absolute inset-0 w-full h-full object-cover" data-id="element-135">
          <source src="https://cdn.magicpatterns.com/uploads/1uajo6gBxCRMo3MUSPKv3C/Video portada web.mov" type="video/mp4" data-id="element-136" />
        </video>
        <div className="absolute inset-0 bg-black/40" data-id="element-137" />
      </div>

      {/* Content */}
      <div className="relative z-10 text-center text-white px-4 max-w-4xl mx-auto flex flex-col items-center mt-16" data-id="element-138">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 0.1
      }} className="mb-6" data-id="element-139">
          <span className="text-xs font-sans uppercase tracking-[0.3em] text-white/90" data-id="element-140">
            — Viajes para mujeres —
          </span>
        </motion.div>

        <motion.h1 initial={{
        y: 30,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} transition={{
        duration: 1,
        delay: 0.3
      }} className="text-5xl md:text-7xl lg:text-[5.5rem] font-serif italic mb-8 leading-[1.1] drop-shadow-lg" data-id="element-141">
          Vive la aventura que <span className="font-bold" data-id="element-142">mereces</span>
        </motion.h1>

        <motion.p initial={{
        y: 20,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} transition={{
        duration: 1,
        delay: 0.5
      }} className="text-base md:text-xl font-sans font-light mb-12 max-w-2xl drop-shadow-md text-white/90 leading-relaxed" data-id="element-143">
          Viajes diseñados exclusivamente para mujeres que buscan reconectar,
          explorar y compartir momentos inolvidables.
        </motion.p>

        <motion.div initial={{
        y: 20,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} transition={{
        duration: 1,
        delay: 0.7
      }} className="flex flex-col sm:flex-row items-center gap-4" data-id="element-144">
          <a href="https://wa.me/56962140004?text=Hola%2C%20estoy%20interesada%20en%20uno%20de%20sus%20viajes." target="_blank" rel="noopener noreferrer" className="hover:bg-rose-light text-white font-sans text-sm uppercase tracking-wider px-8 py-4 rounded-full transition-colors shadow-lg flex items-center gap-2 bg-[#D07C9D]" data-id="element-145">
            Escríbenos <ArrowRight className="w-4 h-4" data-id="element-146" />
          </a>
          <a href="#experiencias" className="bg-transparent border border-white/50 hover:bg-white hover:text-charcoal text-white font-sans text-sm uppercase tracking-wider px-8 py-4 rounded-full transition-colors flex items-center gap-2" data-id="element-147">
            Ver experiencias
          </a>
        </motion.div>
      </div>

      {/* Info Chip */}
      <motion.div initial={{
      opacity: 0,
      x: -20
    }} animate={{
      opacity: 1,
      x: 0
    }} transition={{
      duration: 1,
      delay: 1
    }} className="absolute bottom-8 left-6 md:left-12 bg-white/10 backdrop-blur-md border border-white/20 rounded-full px-4 py-2 flex items-center gap-2 z-20" data-id="element-148">
        <Star className="w-4 h-4 text-rose-blush fill-rose-blush" data-id="element-149" />
        <span className="text-white font-sans text-xs font-medium tracking-wide" data-id="element-150">
          4.9 Valoración
        </span>
      </motion.div>

      {/* Scroll Indicator */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 1,
      delay: 1.2
    }} className="absolute bottom-8 right-6 md:right-12 flex flex-col items-center gap-2 z-20" data-id="element-151">
        <span className="text-white/70 font-sans text-[10px] uppercase tracking-[0.2em]" style={{
        writingMode: 'vertical-rl'
      }} data-id="element-152">
          Scroll
        </span>
        <div className="w-[1px] h-12 bg-white/30 relative overflow-hidden" data-id="element-153">
          <motion.div animate={{
          y: [0, 48, 0]
        }} transition={{
          repeat: Infinity,
          duration: 2,
          ease: 'linear'
        }} className="w-full h-1/2 bg-white absolute top-0" data-id="element-154" />
        </div>
      </motion.div>
    </section>;
}